import { computed, ref } from "vue";
import { DS_BASE_INPUT_CLASSES } from "../constants/classes";
import type { DSBaseInputProps } from "@/src/design_system/form_elements/base_input/types/dsBaseInput";
import { useDSInput } from "@/src/design_system/form_elements/shared/composables/useDSInput";
import { useStateClasses } from "@/src/design_system/shared/composables/useStateClasses";
import { DS_STATE_CLASSES } from "@/src/design_system/shared/constants/stateClasses";

export const useDSBaseInput = (props: DSBaseInputProps) => {
  const inputRef = ref<HTMLInputElement | HTMLTextAreaElement>();
  const { stateClasses } = useStateClasses(props);
  const hasAffixes = computed(() => !props.useTextArea && Boolean(props.prefix || props.suffix || props.clearable));

  const rootClasses = computed(() => {
    return [
      DS_BASE_INPUT_CLASSES.Root,
      stateClasses.value,
      {
        [DS_STATE_CLASSES.InlineEdit]: props.inlineEdit,
        [DS_BASE_INPUT_CLASSES.WithPrefix]: !props.useTextArea && Boolean(props.prefix),
        [DS_BASE_INPUT_CLASSES.WithSuffix]: hasAffixes.value,
        [DS_BASE_INPUT_CLASSES.Textarea]: props.useTextArea,
        [DS_BASE_INPUT_CLASSES.Pointer]: props.cursorPointer,
        [DS_BASE_INPUT_CLASSES.WrapContent]: props.wrapContent,
      },
    ];
  });

  const { focus, blur } = useDSInput(inputRef);

  return {
    focus,
    blur,
    inputRef,
    rootClasses,
  };
};
